<template>
	<div class="indicator_blood_pressure">
		<div class="px-32">
			<IndicatorBase :list="labelBase" :record-date="lastRecord.measureTime" />
		</div>

		<IndicatorTable
			class="mt-28"
			:loading.sync="loading"
			:column="column"
			:list="list"
			:finished="true"
			@more="
                $router.push(
                    `/indicator/bloodFat/list?previewType=${previewType}&patientId=${patientId}`
                )
            "
			@load="getList"
			@onUpdate="clickEdit"
		/>
		<foot-button v-if="previewType !== 'doctor'">
			<van-button type="primary" block @click="clickCreate">记录血脂</van-button>
		</foot-button>
	</div>
</template>

<script>
import IndicatorBase from './components/indicator-base.vue'
import IndicatorTable from './components/history-list.vue'
import MixinList from './mixins/list'
export default {
    name: 'indicatorBloodPressure',
    components: {
        IndicatorBase,
        IndicatorTable
    },
    mixins: [MixinList],
    data: () => ({
        labelBase: [],
        editUrl: '/indicator/bloodFat/edit'
    }),
    computed: {
        column () {
            const column = [
                { prop: 'time', label: '时间', slot: true },
                { prop: 'triglycerides', label: '甘油三酯 mmol/L', width: '70px', slot: true },
                { prop: 'lowDensityFat', label: '低密度脂蛋 白胆固醇 mmol/L', width: '80px', slot: true },
            ]
            if (this.previewType !== 'doctor') {
                column.push({ prop: 'action', label: '编辑', width: '35px', slot: true })
            }
            return column
        }
    },
    methods: {
        async load () {
            const lastInfo = await this.$api.indicator.bloodFatLastInfo({ patientId: this.patientId })
            if (!lastInfo.code) {
                const record = lastInfo.data ?? {}
                if (record.measureTime)
                    record.measureTime = this.$utils.substrLastIndex(record.measureTime, ':', true)
                else
                    record.measureTime = '您还没有上传血脂记录'
                this.lastRecord = record

                this.labelBase = [
                    {
                        value: record.triglycerides,
                        label: '甘油三酯',
                        unit: 'mmol/L',
                        tag: (record.triglycerides ?? false) ? this.$status.bloodStatus[record.triglyceridesStatus] : null
                    },
                    {
                        value: record.lowDensityFat,
                        label: '低密度脂蛋白胆固醇',
                        unit: 'mmol/L',
                        tag: (record.lowDensityFat ?? false) ? this.$status.bloodStatus[record.lowDensityFatStatus] : null
                    }
                ]
            }
            await this.getList()
        },
        async getList () {
            this.loading = true
            const res = await this.$api.indicator.bloodFatPage({
                patientId: this.patientId,
                page: this.page,
                limit: 5
            })
            this.loading = false
            if (!res.code) {
                let arr = res.data.list.map(v => ({
                    ...v,
                    list: [
                        {
                            label: '甘油三酯mmol/L',
                            number: v.triglycerides,
                            status: this.$status.bloodStatus[v.triglyceridesStatus]
                        },
                        {
                            label: '低密度脂蛋白胆固醇mmol/L',
                            number: v.lowDensityFat,
                            status: this.$status.bloodStatus[v.lowDensityFatStatus]
                        }
                    ],
                    time: this.$moment(v.measureTime).format('HH:mm'),
                }))
                this.list = this.initList(this.list, arr)
                this.total = res.data.total
                this.page++
            }
        }
    }
}
</script>

<style scoped lang="less">
.indicator_blood_pressure {
	min-height: calc(100vh - 216px);
	padding: 40px 0;
}
</style>
